import { render } from "./page-flat.vue?vue&type=template&id=09596aaa&scoped=true"
import script from "./page-flat.ts?vue&type=script&lang=js&external"
export * from "./page-flat.ts?vue&type=script&lang=js&external"

import "./page-flat.vue?vue&type=style&index=0&id=09596aaa&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09596aaa"]])

export default __exports__